// frontend/src/services/registry.service.ts
import api from './api';
import { Gift } from '../types';

interface CreateGiftData {
  name: string;
  description?: string;
  price?: number;
  image?: string;
  link?: string;
  status?: 'available' | 'reserved' | 'purchased';
  couple: string;
  category?: string;
  priority?: number;
}

interface ReservationData {
  contributorName: string;
  contributorEmail?: string;
  note?: string;
}

const RegistryService = {
  createGift: async (giftData: CreateGiftData): Promise<Gift> => {
    const response = await api.post<Gift>('/registry', giftData);
    return response.data;
  },

  getCoupleGifts: async (coupleId: string): Promise<Gift[]> => {
    const response = await api.get<Gift[]>(`/registry/couple/${coupleId}`);
    return response.data;
  },

  getGiftById: async (id: string): Promise<Gift> => {
    const response = await api.get<Gift>(`/registry/${id}`);
    return response.data;
  },

  updateGift: async (id: string, giftData: Partial<CreateGiftData>): Promise<Gift> => {
    const response = await api.patch<Gift>(`/registry/${id}`, giftData);
    return response.data;
  },

  deleteGift: async (id: string): Promise<{ deleted: boolean }> => {
    const response = await api.delete<{ deleted: boolean }>(`/registry/${id}`);
    return response.data;
  },

  reserveGift: async (id: string, reservationData: ReservationData): Promise<Gift> => {
    const response = await api.post<Gift>(`/registry/${id}/reserve`, reservationData);
    return response.data;
  },

  purchaseGift: async (id: string, purchaseData: ReservationData): Promise<Gift> => {
    const response = await api.post<Gift>(`/registry/${id}/purchase`, purchaseData);
    return response.data;
  },

  resetGift: async (id: string): Promise<Gift> => {
    const response = await api.post<Gift>(`/registry/${id}/reset`);
    return response.data;
  }
};

export default RegistryService;